export const MODALS = {
    ADD_COUNTRY_CURRENCY: 'ADD_COUNTRY_CURRENCY',
    EDIT_COUNTRY_CURRENCY: 'EDIT_COUNTRY_CURRENCY',
    DELETE_COUNTRY_CURRENCY: 'DELETE_COUNTRY_CURRENCY',
    ADD_CURRENCY: 'ADD_CURRENCY',
    EDIT_CURRENCY: 'EDIT_CURRENCY',
}
